<section class="container py-5 mt-5 mb-2 mb-sm-3 mb-lg-4 mb-xxl-5">
  <h1 class="display-4 pb-3 pb-md-4 pb-lg-5">Social media</h1>

  <div class="row align-items-center pt-xl-2 mb-lg-2 mb-xl-3 mb-xxl-4">
    <div class="col-12">
      <div id="curator-feed">
        <a href="https://curator.io" target="_blank" class="crt-logo crt-tag">Powered by Curator.io</a>
      </div>
    </div>

  </div>
</section>